// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Random = require("../Effect.Random/index.js");
var Sudoku_Internal = require("../Sudoku.Internal/index.js");
var Sudoku_Internal_Solver = require("../Sudoku.Internal.Solver/index.js");
var Sudoku_Wordlist = require("../Sudoku.Wordlist/index.js");
var Sudoku = (function () {
    function Sudoku() {

    };
    Sudoku.value = new Sudoku();
    return Sudoku;
})();
var Wordoku = (function () {
    function Wordoku() {

    };
    Wordoku.value = new Wordoku();
    return Wordoku;
})();
var Colorku = (function () {
    function Colorku() {

    };
    Colorku.value = new Colorku();
    return Colorku;
})();
var Beginner = (function () {
    function Beginner() {

    };
    Beginner.value = new Beginner();
    return Beginner;
})();
var Casual = (function () {
    function Casual() {

    };
    Casual.value = new Casual();
    return Casual;
})();
var Tricky = (function () {
    function Tricky() {

    };
    Tricky.value = new Tricky();
    return Tricky;
})();
var Difficult = (function () {
    function Difficult() {

    };
    Difficult.value = new Difficult();
    return Difficult;
})();
var Challenge = (function () {
    function Challenge() {

    };
    Challenge.value = new Challenge();
    return Challenge;
})();
var valuesEq = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Sudoku && y instanceof Sudoku) {
            return true;
        };
        if (x instanceof Wordoku && y instanceof Wordoku) {
            return true;
        };
        if (x instanceof Colorku && y instanceof Colorku) {
            return true;
        };
        return false;
    };
});
var valuesOrd = new Data_Ord.Ord(function () {
    return valuesEq;
}, function (x) {
    return function (y) {
        if (x instanceof Sudoku && y instanceof Sudoku) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Sudoku) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Sudoku) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Wordoku && y instanceof Wordoku) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Wordoku) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Wordoku) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Colorku && y instanceof Colorku) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 25, column 1 - line 25, column 38): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var valuesEnum = new Data_Enum.Enum(function () {
    return valuesOrd;
}, function (v) {
    if (v instanceof Sudoku) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Wordoku) {
        return new Data_Maybe.Just(Sudoku.value);
    };
    if (v instanceof Colorku) {
        return new Data_Maybe.Just(Wordoku.value);
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 26, column 1 - line 32, column 33): " + [ v.constructor.name ]);
}, function (v) {
    if (v instanceof Sudoku) {
        return new Data_Maybe.Just(Wordoku.value);
    };
    if (v instanceof Wordoku) {
        return new Data_Maybe.Just(Colorku.value);
    };
    if (v instanceof Colorku) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 26, column 1 - line 32, column 33): " + [ v.constructor.name ]);
});
var showValues = new Data_Show.Show(function (v) {
    if (v instanceof Sudoku) {
        return "Sudoku";
    };
    if (v instanceof Wordoku) {
        return "Wordoku";
    };
    if (v instanceof Colorku) {
        return "Colorku";
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 33, column 1 - line 36, column 29): " + [ v.constructor.name ]);
});
var showDifficulty = new Data_Show.Show(function (v) {
    if (v instanceof Beginner) {
        return "Beginner";
    };
    if (v instanceof Casual) {
        return "Casual";
    };
    if (v instanceof Tricky) {
        return "Tricky";
    };
    if (v instanceof Difficult) {
        return "Difficult";
    };
    if (v instanceof Challenge) {
        return "Challenge";
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 52, column 1 - line 57, column 33): " + [ v.constructor.name ]);
});
var randomWord = function (v) {
    return Data_Functor.map(Effect.functorEffect)((function () {
        var $58 = Data_Maybe.fromMaybe("");
        var $59 = Data_Array.index(Sudoku_Wordlist.wordlist);
        return function ($60) {
            return $58($59($60));
        };
    })())(Effect_Random.randomInt(0)(Data_Array.length(Sudoku_Wordlist.wordlist) - 1 | 0));
};
var numChars = [ "1", "2", "3", "4", "5", "6", "7", "8", "9" ];
var mixCellSet = function (v) {
    return Data_Functor.map(Effect.functorEffect)(Sudoku_Internal.CellSet.create(v.value0))(Sudoku_Internal.randomArray(v.value1));
};
var difficultyEq = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Beginner && y instanceof Beginner) {
            return true;
        };
        if (x instanceof Casual && y instanceof Casual) {
            return true;
        };
        if (x instanceof Tricky && y instanceof Tricky) {
            return true;
        };
        if (x instanceof Difficult && y instanceof Difficult) {
            return true;
        };
        if (x instanceof Challenge && y instanceof Challenge) {
            return true;
        };
        return false;
    };
});
var difficultyOrd = new Data_Ord.Ord(function () {
    return difficultyEq;
}, function (x) {
    return function (y) {
        if (x instanceof Beginner && y instanceof Beginner) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Beginner) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Beginner) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Casual && y instanceof Casual) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Casual) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Casual) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Tricky && y instanceof Tricky) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Tricky) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Tricky) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Difficult && y instanceof Difficult) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Difficult) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Difficult) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Challenge && y instanceof Challenge) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 40, column 1 - line 40, column 48): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var difficultyEnum = new Data_Enum.Enum(function () {
    return difficultyOrd;
}, function (v) {
    if (v instanceof Beginner) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Casual) {
        return new Data_Maybe.Just(Beginner.value);
    };
    if (v instanceof Tricky) {
        return new Data_Maybe.Just(Casual.value);
    };
    if (v instanceof Difficult) {
        return new Data_Maybe.Just(Tricky.value);
    };
    if (v instanceof Challenge) {
        return new Data_Maybe.Just(Difficult.value);
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 41, column 1 - line 51, column 36): " + [ v.constructor.name ]);
}, function (v) {
    if (v instanceof Beginner) {
        return new Data_Maybe.Just(Casual.value);
    };
    if (v instanceof Casual) {
        return new Data_Maybe.Just(Tricky.value);
    };
    if (v instanceof Tricky) {
        return new Data_Maybe.Just(Difficult.value);
    };
    if (v instanceof Difficult) {
        return new Data_Maybe.Just(Challenge.value);
    };
    if (v instanceof Challenge) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 41, column 1 - line 51, column 36): " + [ v.constructor.name ]);
});
var diffNum = function (v) {
    if (v instanceof Beginner) {
        return 40;
    };
    if (v instanceof Casual) {
        return 34;
    };
    if (v instanceof Tricky) {
        return 30;
    };
    if (v instanceof Difficult) {
        return 26;
    };
    if (v instanceof Challenge) {
        return 22;
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 130, column 1 - line 130, column 29): " + [ v.constructor.name ]);
};
var generateSudoku = function (restrictDiag) {
    return function (difficulty) {
        var toStringOrLoop = function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return generateSudoku(restrictDiag)(difficulty);
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Sudoku_Internal.gridString(v.value0));
            };
            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 112, column 9 - line 112, column 54): " + [ v.constructor.name ]);
        };
        var removeAt = function (v) {
            return function (idx) {
                return function (grid) {
                    return Sudoku_Internal.replace2D(idx)(new Sudoku_Internal.Possible(v.value1))(grid);
                };
            };
        };
        var reduceBy = function (cs) {
            return function (count) {
                return function (idxs) {
                    return function (grid) {
                        var $46 = count > 64;
                        if ($46) {
                            return Data_Maybe.Nothing.value;
                        };
                        var result = Sudoku_Internal_Solver.solveUnique(restrictDiag)(grid);
                        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.uncons(idxs))(function (v) {
                            if (result instanceof Sudoku_Internal.Unique) {
                                var $49 = count <= 0;
                                if ($49) {
                                    return new Data_Maybe.Just(grid);
                                };
                                var v1 = reduceBy(cs)(count - 1 | 0)(v.tail)(removeAt(cs)(v.head)(grid));
                                if (v1 instanceof Data_Maybe.Nothing) {
                                    return reduceBy(cs)(count)(v.tail)(grid);
                                };
                                if (v1 instanceof Data_Maybe.Just) {
                                    return new Data_Maybe.Just(v1.value0);
                                };
                                throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 100, column 26 - line 103, column 49): " + [ v1.constructor.name ]);
                            };
                            if (result instanceof Sudoku_Internal.NotUnique) {
                                return Data_Maybe.Nothing.value;
                            };
                            if (result instanceof Sudoku_Internal.NoSolution) {
                                return Data_Maybe.Nothing.value;
                            };
                            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 94, column 13 - line 106, column 38): " + [ result.constructor.name ]);
                        });
                    };
                };
            };
        };
        return Control_Bind.bindFlipped(Effect.bindEffect)(toStringOrLoop)(function __do() {
            var cellSet = mixCellSet(Sudoku_Internal.numbers)();
            var mFilled = Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Sudoku_Internal_Solver.solve(restrictDiag))(Data_Either.hush(Sudoku_Internal.readGrid(cellSet)(Sudoku_Internal.emptySudoku)));
            var randIdxs = Sudoku_Internal.randomArray(Data_Array.range(0)(80))();
            return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(reduceBy(cellSet)(81 - diffNum(difficulty) | 0)(randIdxs))(mFilled);
        });
    };
};
var colorChars = [ "R", "O", "Y", "L", "G", "B", "I", "P", "V" ];
var generate = function (opts) {
    var wordMap = function (word) {
        return function (sudoku) {
            var solved = Data_Maybe.fromMaybe(sudoku)(Data_Functor.map(Data_Maybe.functorMaybe)(Sudoku_Internal.gridString)(Sudoku_Internal_Solver.solve(Sudoku_Internal.UniqueDiagonal.value)(Data_Maybe.fromMaybe([  ])(Data_Either.hush(Sudoku_Internal.readNumberGrid(sudoku))))));
            return Data_Map_Internal.fromFoldable(Data_Ord.ordChar)(Data_Foldable.foldableArray)(Data_Array.zip(Data_String_CodeUnits.toCharArray(Sudoku_Internal.diagonalOf(solved)))(Data_String_CodeUnits.toCharArray(word)));
        };
    };
    var mapValues = function (m) {
        return function (str) {
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (s) {
                return function (c) {
                    return s + Data_String_CodeUnits.singleton(Data_Maybe.fromMaybe(".")(Data_Map_Internal.lookup(Data_Ord.ordChar)(c)(m)));
                };
            })("")(Data_String_CodeUnits.toCharArray(str));
        };
    };
    var game = function (opts1) {
        return generateSudoku(opts1.variant)(opts1.difficulty);
    };
    if (opts.values instanceof Sudoku) {
        return game(opts);
    };
    if (opts.values instanceof Colorku) {
        return Data_Functor.map(Effect.functorEffect)(mapValues(Data_Map_Internal.fromFoldable(Data_Ord.ordChar)(Data_Foldable.foldableArray)(Data_Array.zip(numChars)(colorChars))))(game(opts));
    };
    if (opts.values instanceof Wordoku) {
        return function __do() {
            var g = game(opts)();
            var w = randomWord(Data_Unit.unit)();
            return mapValues(wordMap(w)(g))(g);
        };
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 60, column 17 - line 66, column 41): " + [ opts.values.constructor.name ]);
};
module.exports = {
    Sudoku: Sudoku,
    Wordoku: Wordoku,
    Colorku: Colorku,
    Beginner: Beginner,
    Casual: Casual,
    Tricky: Tricky,
    Difficult: Difficult,
    Challenge: Challenge,
    generate: generate,
    generateSudoku: generateSudoku,
    mixCellSet: mixCellSet,
    numChars: numChars,
    colorChars: colorChars,
    randomWord: randomWord,
    diffNum: diffNum,
    valuesEq: valuesEq,
    valuesOrd: valuesOrd,
    valuesEnum: valuesEnum,
    showValues: showValues,
    difficultyEq: difficultyEq,
    difficultyOrd: difficultyOrd,
    difficultyEnum: difficultyEnum,
    showDifficulty: showDifficulty
};
